
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSensorGpsMedium as ObiSensorGpsMediumElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-sensor-gps-medium.js';
 
 
 

 
 export const ObiSensorGpsMedium = createComponent({
   react: React,
   tagName: 'obi-sensor-gps-medium',
   elementClass: ObiSensorGpsMediumElement,
   events: {
     
   }
  });
 
 